"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInspectMode = exports.setShowViewportSizeOnResize = exports.hideHighlight = exports.highlightNode = exports.disable = exports.enable = void 0;
var nodeManager_1 = require("../lib/nodeManager");
var DOM_1 = require("./DOM");
var _1 = __importDefault(require("licia/$"));
var h_1 = __importDefault(require("licia/h"));
var evalCss_1 = __importDefault(require("licia/evalCss"));
var defaults_1 = __importDefault(require("licia/defaults"));
var extend_1 = __importDefault(require("licia/extend"));
var connector_1 = __importDefault(require("../lib/connector"));
var root_1 = __importDefault(require("licia/root"));
var toBool_1 = __importDefault(require("licia/toBool"));
var cssSupports_1 = __importDefault(require("licia/cssSupports"));
var luna_dom_highlighter_1 = __importDefault(require("luna-dom-highlighter"));
var objManager = __importStar(require("../lib/objManager"));
var domHighlighter;
var isCssLoaded = false;
var $container;
var isEnable = false;
var showInfo = (0, cssSupports_1.default)('clip-path', 'polygon(50% 0px, 0px 100%, 100% 100%)');
var hasTouchSupport = 'ontouchstart' in root_1.default;
var css = require('luna-dom-highlighter/luna-dom-highlighter.css').replace('/*# sourceMappingURL=luna-dom-highlighter.css.map*/', '');
function enable() {
    if (isEnable) {
        return;
    }
    var container = (0, h_1.default)('div', {
        class: '__chobitsu-hide__',
        style: {
            all: 'initial',
        },
    });
    $container = (0, _1.default)(container);
    document.documentElement.appendChild(container);
    var domHighlighterContainer = null;
    var shadowRoot = null;
    if (container.attachShadow) {
        shadowRoot = container.attachShadow({ mode: 'open' });
    }
    else if (container.createShadowRoot) {
        shadowRoot = container.createShadowRoot();
    }
    if (shadowRoot) {
        var style = document.createElement('style');
        style.textContent = css;
        style.type = 'text/css';
        shadowRoot.appendChild(style);
        domHighlighterContainer = document.createElement('div');
        shadowRoot.appendChild(domHighlighterContainer);
    }
    else {
        domHighlighterContainer = document.createElement('div');
        container.appendChild(domHighlighterContainer);
        if (!isCssLoaded) {
            (0, evalCss_1.default)(css);
            isCssLoaded = true;
        }
    }
    domHighlighter = new luna_dom_highlighter_1.default(domHighlighterContainer, {
        monitorResize: (0, toBool_1.default)(root_1.default.ResizeObserver),
        showInfo: showInfo,
    });
    window.addEventListener('resize', resizeHandler);
    isEnable = true;
}
exports.enable = enable;
function disable() {
    domHighlighter.destroy();
    $container.remove();
    window.removeEventListener('resize', resizeHandler);
    isEnable = false;
}
exports.disable = disable;
function highlightNode(params) {
    var nodeId = params.nodeId, highlightConfig = params.highlightConfig, objectId = params.objectId;
    var node;
    if (nodeId) {
        node = (0, nodeManager_1.getNode)(nodeId);
    }
    if (objectId) {
        node = objManager.getObj(objectId);
    }
    if (node.nodeType !== 1 && node.nodeType !== 3)
        return;
    (0, defaults_1.default)(highlightConfig, {
        contentColor: 'transparent',
        paddingColor: 'transparent',
        borderColor: 'transparent',
        marginColor: 'transparent',
    });
    if (!showInfo) {
        (0, extend_1.default)(highlightConfig, {
            showInfo: false,
        });
    }
    domHighlighter.highlight(node, highlightConfig);
}
exports.highlightNode = highlightNode;
function hideHighlight() {
    domHighlighter.hide();
}
exports.hideHighlight = hideHighlight;
var showViewportSizeOnResize = false;
function setShowViewportSizeOnResize(params) {
    showViewportSizeOnResize = params.show;
}
exports.setShowViewportSizeOnResize = setShowViewportSizeOnResize;
var highlightConfig = {};
var inspectMode = 'none';
function setInspectMode(params) {
    highlightConfig = params.highlightConfig;
    inspectMode = params.mode;
}
exports.setInspectMode = setInspectMode;
function getElementFromPoint(e) {
    if (hasTouchSupport) {
        var touch = e.touches[0] || e.changedTouches[0];
        return document.elementFromPoint(touch.clientX, touch.clientY);
    }
    return document.elementFromPoint(e.clientX, e.clientY);
}
var lastNodeId = -1;
function moveListener(e) {
    if (inspectMode === 'none')
        return;
    var node = getElementFromPoint(e);
    if (!node || !(0, nodeManager_1.isValidNode)(node)) {
        return;
    }
    var nodeId = (0, nodeManager_1.getNodeId)(node);
    if (!nodeId) {
        nodeId = (0, DOM_1.pushNodesToFrontend)(node);
    }
    highlightNode({
        nodeId: nodeId,
        highlightConfig: highlightConfig,
    });
    if (nodeId !== lastNodeId) {
        connector_1.default.trigger('Overlay.nodeHighlightRequested', {
            nodeId: nodeId,
        });
        lastNodeId = nodeId;
    }
}
function outListener() {
    if (inspectMode === 'none')
        return;
    hideHighlight();
}
function clickListener(e) {
    if (inspectMode === 'none')
        return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var node = getElementFromPoint(e);
    connector_1.default.trigger('Overlay.inspectNodeRequested', {
        backendNodeId: (0, nodeManager_1.getNodeId)(node),
    });
    lastNodeId = -1;
    hideHighlight();
}
function addEvent(type, listener) {
    document.documentElement.addEventListener(type, listener, true);
}
if (hasTouchSupport) {
    addEvent('touchstart', moveListener);
    addEvent('touchmove', moveListener);
    addEvent('touchend', clickListener);
}
else {
    addEvent('mousemove', moveListener);
    addEvent('mouseout', outListener);
    addEvent('click', clickListener);
}
var viewportSize = (0, h_1.default)('div', {
    class: '__chobitsu-hide__',
    style: {
        position: 'fixed',
        right: 0,
        top: 0,
        background: '#fff',
        fontSize: 13,
        opacity: 0.5,
        padding: '4px 6px',
    },
});
function resizeHandler() {
    if (!showViewportSizeOnResize)
        return;
    $viewportSize.text("".concat(window.innerWidth, "px \u00D7 ").concat(window.innerHeight, "px"));
    if (viewportSizeTimer) {
        clearTimeout(viewportSizeTimer);
    }
    else {
        document.documentElement.appendChild(viewportSize);
    }
    viewportSizeTimer = setTimeout(function () {
        $viewportSize.remove();
        viewportSizeTimer = null;
    }, 1000);
}
var $viewportSize = (0, _1.default)(viewportSize);
var viewportSizeTimer;
